/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { colors } from "@farmlands/mui-theme";
import { Box, Link } from "@mui/material";
import React from "react";
import { toast } from "react-toastify";

import { TestIds } from "../testIds";
import { log } from "../util/log";

import MaterialSymbol from "./MaterialSymbol";
import ToastIcon from "./ToastIcon";

interface ShareButtonProps {
  label: string;
  content: {
    title: string;
    text: string;
    url?: string;
  };
}
export const ShareButton: React.FC<ShareButtonProps> = (props) => {
  const onClick = () => {
    if (navigator.share) {
      navigator
        .share(props.content)
        .then(() => log("Successful share"))
        .catch((err) => log("Error sharing", err));
    } else {
      navigator.clipboard
        .writeText(props.content.text)
        .then(() => {
          toast("Details copied to clipboard", {
            type: "success",
            icon: <ToastIcon>inventory</ToastIcon>,
          });
        })
        .catch(() => {
          toast("Copy to clipboard unsuccesful", {
            type: "error",
          });
        });
    }
  };
  return (
    <Box
      onClick={onClick}
      sx={{ display: "flex", mt: "auto", gap: "4px", color: colors.primary500, cursor: "pointer" }}
    >
      <MaterialSymbol>ios_share</MaterialSymbol>
      <Link variant="body2" data-testid={TestIds.feat.orders.details.shareOrder}>
        {props.label}
      </Link>
    </Box>
  );
};

export default ShareButton;
